<template>
  <router-link
    :to="link"
    class="relative w-full flex bg-grey-1 cursor-pointed hover:bg-blue-2 md:rounded-lg shadow-md my-2 transition-bg transition-250 | channel-thread-item"
  >
    <div
      class="flex items-center justify-center px-2 py-2 md:px-4 bg-grey-2 transition-bg transition-250 md:rounded-l-lg | channel-thread-item-avatar"
    >
      <avatar :user="thread.owner" class="w-12 h-12 md:w-16 md:h-16" />
    </div>
    <div class="flex-1 flex flex-col justify-center px-2 py-2 ml-2">
      <div
        class="text-lg md:text-xl font-semibold text-blue-6 transition-color transition-250 | channel-thread-item-title"
      >
        <svgicon class="w-4 h-4 text-yellow-7 fill-current inline transition-color transition-250" icon="pin" v-if="thread.pinned"></svgicon>
        <lock-icon class="text-yellow-7 inline transition-color transition-250" :class="{'ml-1': thread.pinned}" v-if="thread.locked"></lock-icon>
        {{ thread.title }}
      </div>
      <div class="text-md text-grey-7 flex items-baseline">
        <username :user="thread.owner" />
        <span class="uppercase ml-2 font-semibold text-sm opacity-75 text-grey-7">{{ fromNow(thread.created_at) }}</span>
      </div>
      <div class="text-sm mt-1 opacity-75 uppercase lg:hidden">
        <span class="font-semibold">Replies</span>
        <span class="text-blue-7 font-bold ml-1">{{ thread.reply_count }}</span>
        <span class="font-semibold ml-2" v-if="thread.latest_reply">Last Reply</span>
        <span
          class="text-yellow-7 font-bold ml-1"
          v-if="thread.latest_reply"
        >{{ fromNow(thread.latest_reply) }}</span>
        <span class="text-yellow-6 font-bold ml-2" v-if="thread.new">New!</span>
      </div>
    </div>
    <div
      class="hidden lg:flex flex-col justify-center text-sm opacity-75 uppercase text-grey-7 px-4 py-2 ml-2"
    >
      <div class="text-right">
        <span class="font-semibold">Replies</span>
        <span class="text-blue-7 font-bold ml-1">{{ thread.reply_count }}</span>
      </div>
      <div class="text-right">
        <span class="font-semibold" v-if="thread.latest_reply">Last Reply</span>
        <span
          class="text-yellow-7 font-bold ml-1"
          v-if="thread.latest_reply"
        >{{ fromNow(thread.latest_reply) }}</span>
      </div>
    </div>
    <div class="new-badge" v-if="thread.new">
      <alert-circle-icon></alert-circle-icon>
    </div>
  </router-link>
</template>

<script>
import DateTime from "@/mixins/DateTime"
import { indexOf } from "lodash"
import { AlertCircleIcon, LockIcon } from 'vue-feather-icons'

export default {
  name: "ChannelThreadItem",
  mixins: [DateTime],
  components: {
    AlertCircleIcon, LockIcon
  },
  props: {
    thread: {
      required: true
    }
  },
  computed: {
    link() {
      let to = {
        name: "threads.show",
        params: {
          channel: this.$route.params.channel,
          thread: this.thread.slug
        },
        query: {}
      }

      if (this.thread.new) {
        if (
          this.thread.replies.length !== 0 &&
          this.thread.new.id !== this.thread.replies[0]
        ) {
          let index = indexOf(this.thread.replies, this.thread.new.id) + 1,
            page = Math.ceil(index / 25)
          if (page > 1) to.query.page = page
          to.hash = "#reply-" + this.thread.new.id
        } else {
          to.hash = "#thread"
        }
      } else {
        let page = Math.ceil(this.thread.replies.length / 25)
        if (page > 1) to.query.page = page
      }

      return to
    }
  }
}
</script>

<style lang="scss">
.channel-thread-item:hover .channel-thread-item-title {
  @apply text-yellow-6;
}

.channel-thread-item:hover .channel-thread-item-avatar {
  @apply bg-grey-3;
}
</style>
